import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import ManageHotelForm from "../forms/ManageHotelForm/ManageHotelForm";
import { useAppContext } from "../contexts/AppContext";
import * as apiClient from "../api-client";

const EditHotel = () => {
  const { slug } = useParams<{ slug: string }>();
  const { showToast } = useAppContext();

  const { data: hotel, isLoading: isFetching } = useQuery(
    ["hotel", slug],
    () => apiClient.fetchHotelBySlug(slug!),
    {
      enabled: !!slug, // Only run this query if hotelId is available
    }
  );

  const { mutate, isLoading: isUpdating } = useMutation(apiClient.updateMyHotelById, {
    onSuccess: () => {
      showToast({ message: "Hotel Updated!", type: "SUCCESS" });
    },
    onError: () => {
      showToast({ message: "Error Updating Hotel", type: "ERROR" });
    },
  });

  const handleSave = (hotelFormData: FormData) => {
    mutate(hotelFormData);
  };

  if (isFetching) {
    return <div>Loading hotel data...</div>;
  }

  return (
    <ManageHotelForm
      onSave={handleSave}
      isLoading={isUpdating}
      hotel={hotel}
    />
  );
};

export default EditHotel;
